module.exports = __webpack_public_path__ + "img/a77bfa4.jpg";